import type { PrivacyTranslation } from './types';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const privacyUr: PrivacyTranslation = {
  nav: 'رازداری',
  title: 'رازداری',
  description:
    'آپ کی ورک اسپیس گفتگو کتنی دیر رکھتی ہے، اور جب کوئی گاہک اپنا ڈیٹا مانگے یا اسے مٹانے کو کہے تو آپ کیا کر سکتے ہیں۔',
  retention: {
    title: 'گفتگو کتنی دیر رکھی جاتی ہے',
    description:
      'جن حل شدہ گفتگو کا آخری پیغام اس سے پرانا ہے، وہ اپنی فائلوں سمیت Chatwoot اور Hamnivo دونوں سے مٹا دی جاتی ہیں۔ جن گاہکوں کی کوئی گفتگو باقی نہیں رہتی، انہیں بھی ہٹا دیا جاتا ہے۔ رپورٹوں کے اعداد ویسے ہی رہتے ہیں۔',
    guide: 'گفتگو رکھنے کی مدت کیسے کام کرتی ہے',
    loading: 'گفتگو رکھنے کی مدت لوڈ ہو رہی ہے',
    label: 'حل شدہ گفتگو رکھیں',
    hint: 'مدت آخری پیغام سے گنی جاتی ہے۔ جس گفتگو میں گاہک دوبارہ لکھے، وہ رکھی جاتی ہے۔',
    forever: 'جب تک ہاتھ سے نہ مٹائی جائے',
    periods: {
      d90: '3 مہینے',
      d180: '6 مہینے',
      d365: '1 سال',
      d730: '2 سال',
      d1095: '3 سال',
      d1825: '5 سال',
      d2555: '7 سال',
    },
    counting: 'گفتگو گنی جا رہی ہے…',
    preview: 'آج اس سے پرانی حل شدہ گفتگو: {{n}}۔',
    startsOn:
      'مٹانا {{date}} سے شروع ہوگا، محفوظ کرنے کے ایک ہفتے بعد، تاکہ اسے اب بھی واپس لیا جا سکے۔ ہر مالک کو اس کی ای میل ملتی ہے۔',
    atOnce: 'اس سے کچھ بھی پہلے نہیں مٹتا، اس لیے یہ فوراً لاگو ہوتا ہے۔',
    save: 'محفوظ کریں',
    saved: 'محفوظ ہو گیا۔',
    pending:
      '{{date}} سے، {{period}} سے پرانی حل شدہ گفتگو مٹا دی جائے گی۔ تب تک آپ اسے واپس لے سکتے ہیں۔',
    undo: 'واپس لیں',
    undone: 'واپس لے لیا گیا۔ پہلے سے زیادہ کچھ نہیں مٹے گا۔',
    progress: 'اب تک مٹائے گئے: {{conversations}} گفتگو اور {{customers}} گاہک۔',
    checked: 'آخری بار {{date}} کو جانچا گیا۔',
    running: 'پرانی گفتگو مٹائی جا رہی ہے۔ پہلی بار اس میں وقت لگ سکتا ہے۔',
    blocked:
      'مٹانا رک گیا ہے: Chatwoot نے Hamnivo کو گفتگو مٹانے نہیں دی۔ Hamnivo جس Chatwoot صارف سے جڑتا ہے، اس کا ایڈمنسٹریٹر ہونا ضروری ہے۔ Hamnivo میں بھی کچھ نہیں مٹایا گیا۔ یہ ٹھیک ہوتے ہی مٹانا خود بخود دوبارہ شروع ہو جائے گا۔',
    kept: 'آرڈر، ادائیگیاں اور آڈٹ لاگ رکھے جاتے ہیں: یہ کاروباری ریکارڈ ہیں۔',
  },
  customers: {
    title: 'کسی گاہک کا ڈیٹا',
    description:
      'کسی گاہک کو تلاش کریں، تاکہ اس کی ساری معلومات ڈاؤن لوڈ کر سکیں، یا اسے ہر جگہ سے مٹا سکیں، Chatwoot سمیت۔',
    guide: 'ڈاؤن لوڈ کرنا اور مٹانا',
    search: 'گاہک تلاش کریں',
    searchHint:
      'نام، ای میل پتہ، فون نمبر، آپ کے سسٹم میں ان کی ID، یا کوئی گاہک یا گفتگو ID۔ کم از کم 2 حروف۔',
    find: 'تلاش کریں',
    searching: 'گاہک تلاش کیے جا رہے ہیں',
    none: '“{{query}}” سے کوئی گاہک میل نہیں کھاتا۔',
    results: 'ملنے والے گاہک',
    unnamed: 'بغیر نام کا وزیٹر',
    erased: 'مٹایا گیا',
    lastSeen: 'آخری بار {{date}} کو دیکھے گئے',
    loading: 'گاہک لوڈ ہو رہا ہے',
    id: 'گاہک ID',
    brand: 'برانڈ',
    conversations: 'گفتگو',
    orders: 'آرڈر',
    memories: 'یادیں',
    shared:
      'ان کے Chatwoot رابطے میں کسی دوسرے برانڈ کی گفتگو بھی ہے۔ وہ گفتگو اور رابطہ باقی رہیں گے۔',
    ordersKept:
      'ان کے آرڈر کاروباری ریکارڈ کے طور پر رہیں گے، ان کے نام اور ڈیلیوری کی تفصیل کے بغیر۔',
    erasedNote:
      'یہ گاہک مٹا دیا گیا ہے۔ صرف ایک گمنام ریکارڈ باقی ہے، کیونکہ ان کے آرڈر اسی سے جڑے ہیں۔',
    close: 'بند کریں',
    download: 'ان کا ڈیٹا ڈاؤن لوڈ کریں',
    erase: 'اس گاہک کو مٹائیں',
    exportStarted: 'فائل تیار ہو رہی ہے۔ تیار ہونے پر یہ درخواستوں میں نظر آئے گی۔',
    eraseStarted: 'مٹانا شروع ہو گیا ہے۔ مکمل ہونے پر یہ درخواستوں میں نظر آئے گا۔',
    reason: {
      label: 'کیوں',
      access_request: 'انہوں نے اپنا ڈیٹا مانگا',
      erasure_request: 'انہوں نے مٹانے کو کہا',
      other: 'کوئی اور وجہ',
    },
    reference: 'حوالہ (اختیاری)',
    referenceHint: 'آپ کا ٹکٹ یا کیس نمبر۔ اس میں ذاتی تفصیل نہ لکھیں۔',
    exportTitle: '{{name}} کا ڈیٹا ڈاؤن لوڈ کریں',
    exportBody:
      'فائل میں ان کی پروفائل، ان کی گفتگو جیسی انہوں نے دیکھی، دونوں طرف بھیجی گئی فائلیں، رضامندیاں، یادیں، آرڈر اور فیڈبیک ہوتے ہیں۔ اندرونی نوٹ شامل نہیں ہوتے۔ آپ اسے 24 گھنٹے تک ڈاؤن لوڈ کر سکتے ہیں، اور ہر ڈاؤن لوڈ درج ہوتا ہے۔',
    exportSubmit: 'فائل تیار کریں',
    eraseTitle: '{{name}} کو مٹائیں',
    eraseBody:
      'اس سے Chatwoot میں ان کی گفتگو اور رابطہ، اور Hamnivo میں ان سے متعلق ہر چیز مٹ جاتی ہے: پروفائل، گفتگو، فائلیں، یادیں، فیڈبیک اور ترجیحات۔ اسے واپس نہیں کیا جا سکتا۔',
    eraseKept:
      'باقی رہیں گے: آرڈر اور ادائیگیاں، ان کے نام اور ڈیلیوری کی تفصیل کے بغیر، رضامندی کے ریکارڈ اور آڈٹ لاگ۔',
    confirm: 'تصدیق کے لیے گاہک ID لکھیں: {{id}}',
    confirmMismatch: 'گاہک ID بالکل ویسے ہی لکھیں جیسے دکھائی گئی ہے۔',
    eraseSubmit: 'ہر جگہ سے مٹائیں',
  },
  requests: {
    title: 'درخواستیں',
    description: 'ایکسپورٹ اور مٹانے کی درخواستیں، نئی پہلے۔',
    loading: 'درخواستیں لوڈ ہو رہی ہیں',
    empty: 'ابھی تک کوئی ایکسپورٹ یا مٹانے کی درخواست نہیں۔',
    kind: { export: 'ایکسپورٹ', erase: 'مٹانا' },
    state: {
      queued: 'انتظار میں',
      running: 'جاری ہے',
      completed: 'ہو گیا',
      blocked: 'رکا ہوا',
      failed: 'ناکام',
    },
    by: '{{name}} کی طرف سے',
    download: 'ڈاؤن لوڈ کریں',
    until: '{{date}} تک',
    gone: '24 گھنٹے بعد مٹا دی گئی',
    exported: 'گفتگو: {{conversations}}، فائلیں: {{files}}',
    erasedCounts: 'مٹائی گئی گفتگو: {{conversations}}، Chatwoot رابطے: {{contacts}}',
    blocked:
      'Chatwoot نے Hamnivo کو مٹانے نہیں دیا۔ Hamnivo جس Chatwoot صارف سے جڑتا ہے، اسے ایڈمنسٹریٹر ہونا چاہیے۔ Hamnivo میں کچھ نہیں مٹایا گیا۔ اسے ٹھیک کرنے کے بعد دوبارہ درخواست کریں۔',
    failed: 'یہ مکمل نہیں ہوا۔ دوبارہ درخواست کریں۔',
  },
};
